import diff from 'object-diff'

const objectsDiff = (a, b) => {
	return !!Object.keys(diff(a, b)).length
}

export default objectsDiff
